import styled from 'styled-components';

import { DEVICE } from '@hero/constants';

const SignUpRedirect = styled.div`
  align-items: center;
  background-color: var(--color-white-main);
  border: 1px solid var(--color-border-default);
  border-radius: var(--size-border-radius-md);
  display: flex;
  flex-direction: column;
  gap: 24px;
  justify-content: center;
  padding: 40px;
  width: 458px;

  ${DEVICE.mobile.max} {
    padding: 24px;
    width: 100%;
  }
`;

const SignUpRedirectIcon = styled.div`
  align-items: center;
  border: 1px solid var(--color-accent-primary-default);
  border-radius: var(--size-border-radius-circle);
  display: flex;
  height: 96px;
  justify-content: center;
  width: 96px;
`;

const SignUpRedirectBody = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const SignUpRedirectText = styled.div`
  color: var(--color-accent-secondary-default);
  margin: 0 auto;
  max-width: 256px;
  text-align: center;
`;
export { SignUpRedirect, SignUpRedirectBody, SignUpRedirectIcon, SignUpRedirectText };
